import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { PHOTO_UPLOAD_API } from "../../../constants/constants";

export const fileUploadApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: (data) => {
        return {
          url: `${PHOTO_UPLOAD_API}${API_URL.uploadFile}`,
          method: "PATCH",
          body: data,
        };
      },
    }),
  }),
});

export const { useUploadFileMutation } = fileUploadApi;
